<template>
  <v-container class="py-1" :style="{ 'max-width': maxWidth }" style="position:fixed; z-index: 3;" >
    <v-slide-group show-arrows>
      <draggable v-model="$store.state.tagsView.visitedViews">
        <v-slide-item
          v-for="tag in $store.state.tagsView.visitedViews"
          :key="tag.path"
        >
          <v-chip
            small
            close
            link
            active-class="primary white--text"
            :to="{ path: tag.path, query: tag.query, fullPath: tag.fullPath }"
            @click:close="closeSelectedTag(tag)"
            ref="tag"
            class="ma-1"
          >
            <v-avatar left v-if="getMenuIcon(tag)">
              <v-icon>{{ getMenuIcon(tag) }}</v-icon>
            </v-avatar>
            {{getMenuTitle(tag)}}
          </v-chip>
        </v-slide-item>
      </draggable>
    </v-slide-group>
  </v-container>
</template>
<script>
import envs from '@/envs'
import store from '@/store'
import draggable from 'vuedraggable'

export default {
  name: 'TagView',
  components: {
    draggable
  },
  data: () => ({
    maxWidth: 'calc(100% - 256px)'
  }),
  computed: {
    visitedViews() {
      return store.state.tagsView.visitedViews
    }
  },
  watch: {
    $route() {
      if (this.exceptUrl()) return
      this.$nextTick(() => {
        this.addViewTags()
        this.moveToCurrentTag()
      })
    },
    '$store.state.menu.flag.navigationDrawer'(newValue) {
      if (newValue) {
        this.maxWidth = 'calc(100% - 256px)'
      } else {
        this.maxWidth = '100%'
      }
    }
  },
  mounted() {
    if (this.exceptUrl()) return
    this.addViewTags()
  },
  methods: {
    exceptUrl() {
      if (
        envs.framework.whiteList.some(whiteUrl => {
          return this.$route.path === whiteUrl
        })
      ) { return true }
      return false
    },
    isActive(route) {
      return route.path === this.$route.path
    },
    addViewTags() {
      const { name } = this.$route
      if (name) {
        store.dispatch('AddView', this.$route)
      }
    },
    moveToCurrentTag() {
      const tags = this.$refs.tag
      this.$nextTick(() => {
        if (!tags) return
        for (const tag of tags) {
          if (tag.to.path === this.$route.path) {
            if (tag.to.fullPath !== this.$route.fullPath) {
              store.dispatch('UpdateVisitedView', this.$route)
            }
            break
          }
        }
      })
    },
    getMenuTitle(tag) {
      let currentMenu = _.find(store.state.menu.menus, {
        href: tag.path
      })
      if (!currentMenu) currentMenu = tag.name
      else currentMenu = currentMenu.menu_id
      return this.$t(currentMenu)
    },
    getMenuIcon(tag) {
      let currentMenu = _.find(store.state.menu.menus, {
        href: tag.path
      })
      if (!currentMenu) return
      let currentIcon = currentMenu.icon_path
      return currentIcon
    },
    closeSelectedTag(view) {
      event.preventDefault()
      store.dispatch('DelView', view).then(({ visitedViews }) => {
        if (this.isActive(view)) {
          const latestView = visitedViews.slice(-1)[0]
          if (latestView) {
            this.$router.push(latestView)
          } else {
            this.$router.push('/')
          }
        }
      })
    }
  }
}
</script>
